import { t } from 'i18next';
import { IVisibleTableColumn } from 'types/TableColumn';
import { CertificationStatusReportActiveSortableColumnKey } from '../CertificationColumnDialogs/CertificationStatusReportActiveColumnsDialog';

export const defaultCertificationStatusReportActiveColumns: IVisibleTableColumn<CertificationStatusReportActiveSortableColumnKey>[] =
  [
    { key: 'member', title: 'member', visible: true },
    { key: 'certification', title: 'certification', visible: true },
    { key: 'issueDate', title: 'issueDate', visible: true },
    { key: 'expirationDate', title: 'expirationDate', visible: true },
    { key: 'renewal', title: 'renewal', visible: true },
  ];

export const certificationStatusReportActiveColumnLabelLookup: Record<
  CertificationStatusReportActiveSortableColumnKey,
  string
> = {
  member: t('Employee'),
  certification: t('Certification'),
  issueDate: t('Issued/Renewed'),
  expirationDate: t('Expires'),
  renewal: t('Renewal'),
};


export const unsupportedCertificationAttachmentFileTypeMessage = 'Unsupported File Type';

export const supportedCertificationAttachmentFileExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'docx'] as const;

export const supportedCertificationAttachmentFileType = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export type TSupportedCertificationAttachmentFileExtensions =
  (typeof supportedCertificationAttachmentFileExtensions)[number];

export type TSupportedCertificationAttachmentFileType = (typeof supportedCertificationAttachmentFileType)[number];

export const fileTypeToFileExtensionLookupCertificationAttachment: Record<
  TSupportedCertificationAttachmentFileType,
  TSupportedCertificationAttachmentFileExtensions
> = {
  'image/png': 'png',
  'image/jpg': 'jpg',
  'image/jpeg': 'jpeg',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
};

export const fileNameExtensionToFileExtensionLookupCertificationAttachment: Record<
  TSupportedCertificationAttachmentFileExtensions,
  TSupportedCertificationAttachmentFileExtensions
> = {
  png: 'png',
  jpg: 'jpeg',
  jpeg: 'jpeg',
  pdf: 'pdf',
  docx: 'docx',
};
